import React from 'react';
import PropTypes from 'prop-types';
import { bannerUpdate } from 'shared/actions/globals';
import { connect } from 'react-redux';
import { googletagSlotFn } from './TargetingCheck';

export const Banners = connect(
  ({ globals }) => ({
    targeting: globals.targeting && globals.targeting.targetingSlot,
  }),
  dispatch => ({ dispatch }),
)(
  class Banners extends React.Component {
    static propTypes = {
      targeting: PropTypes.shape().isRequired,
      id: PropTypes.string,
      dispatch: PropTypes.func.isRequired,
      targetingAds: PropTypes.arrayOf(
        PropTypes.shape({
          dfpNetworkId: PropTypes.string,
          adUnit: PropTypes.string,
          slotId: PropTypes.string,
        }),
      ),
    };
    static defaultProps = {
      targeting: {},
      id: '',
      targetingAds: null,
    };
    componentWillMount() {
      this.props.dispatch(bannerUpdate({ id: this.props.id, addComponent: true }));
      googletagSlotFn({ id: this.props.id, targetingAds: this.props.targetingAds });
    }
    componentDidMount() {
      googletagSlotFn({ id: this.props.id, targetingAds: this.props.targetingAds });
    }
    componentDidUpdate() {
      googletagSlotFn({ id: this.props.id, targetingAds: this.props.targetingAds });
    }
    componentWillUnmount() {
      this.props.dispatch(bannerUpdate({ id: this.props.id, deleteComponent: true }));
      googletagSlotFn({
        id: this.props.id,
        targetingAds: this.props.targetingAds,
        componentWillUnmount: true,
      });
    }

    render() {
      const dev = __DEVBANNER__;
      const slot = googletagSlotFn(this.props, true);
      const { targeting = {} } = this.props;
      if (typeof targeting !== 'object') {
        console.error('targeting!==object R8Ys8PX8T9ltgzphr');
        return '';
      }
      return (
        <div
          style={
            dev
              ? {
                  width: '100%',
                  minHeight: '200px',
                  backgroundColor: '#ffb900',
                  border: '3px solid #a73c3c',
                }
              : {}
          }
          id={dev ? '' : slot.slotId}
        >
          {dev ? (
            <React.Fragment>
              <div>________________slot_________________</div>
              <React.Fragment>
                {' '}
                {Object.keys(slot).map(a => (
                  <div key={a}>
                    {a} : {a === 'sizes' ? JSON.stringify(slot[a]) : slot[a]}
                  </div>
                ))}
              </React.Fragment>
              <div>________________targeting_________________</div>

              <React.Fragment>
                {' '}
                {Object.keys(targeting).map(a => (
                  <div key={`${a}next`}>
                    {a} : {targeting[a]}
                  </div>
                ))}
              </React.Fragment>
              <div>________________end_block_________________</div>
            </React.Fragment>
          ) : (
            ''
          )}
        </div>
      );
    }
  },
);



// WEBPACK FOOTER //
// ./src/shared/modules/googletag/index.js